import type { StyleLibrary } from "schemas/generated/project";

import { findNeutralColorsByBrightness } from "replo-utils/lib/colors";

export function mergeStyleLibraries(
  urlStyleLibrary: StyleLibrary,
  brandColors?: { hex: string; type: string; brightness: number }[],
  brandFonts?: { name: string; type: string }[],
): StyleLibrary {
  const merged = structuredClone(urlStyleLibrary);

  if (brandColors?.length) {
    const primary = brandColors.find((c) => c.type === "accent");
    const secondary = brandColors.find((c) => c.type === "dark");

    if (primary) {
      merged.colors.brand.primary.color = primary.hex;
    }
    if (secondary) {
      merged.colors.brand.secondary.color = secondary.hex;
    }

    const neutrals = findNeutralColorsByBrightness(brandColors);
    if (neutrals.light) {
      merged.colors.neutrals.light = neutrals.light;
    }
    if (neutrals.subtle) {
      merged.colors.neutrals.subtle = neutrals.subtle;
    }
    if (neutrals.muted) {
      merged.colors.neutrals.muted = neutrals.muted;
    }
    if (neutrals.dark) {
      merged.colors.neutrals.dark = neutrals.dark;
    }
  }

  if (brandFonts?.length) {
    const headingFont = brandFonts.find((f) => f.type === "title");
    const bodyFont = brandFonts.find((f) => f.type === "body");

    const headingFontName =
      headingFont?.name ?? brandFonts[0]?.name ?? merged.typography.h1.name;
    const bodyFontName =
      bodyFont?.name ?? brandFonts[1]?.name ?? merged.typography.body.name;

    if (headingFontName) {
      merged.typography.h1.name = headingFontName;
      merged.typography.h2.name = headingFontName;
      merged.typography.h3.name = headingFontName;
      merged.typography.h4.name = headingFontName;
    }

    if (bodyFontName) {
      merged.typography.body.name = bodyFontName;
    }
  }

  return merged;
}
